<template>
    <div>
        <answer-portrait :h5ConfigData="h5ConfigData" :owner="owner"></answer-portrait>
        <div class="answer-content has-affix" :class="{ answerContentSjtu: owner === 'SJTU' }">
            <div class="answer-content-tt">{{ answerModel.recommend.Title }}</div>
            <div v-for="(item, index) in answerModel.recommend.Items" :key="index" class="blue" @click="changeInput(item)">
                <span>{{ index + 1 }}</span
                >: {{ item }}
            </div>
            <div v-if="!!answerModel.recommend.PostfixTitle" class="answer-content-another">{{ answerModel.recommend.PostfixTitle }}</div>
            <!-- <div class="answer-content-affix" v-if="answerModel.recommend.Items.length > 5">
                <button type="text" @click.stop="changeInput('换一批')"><img src="../../assets/imgs/change.png" alt="change" />换一批</button>
            </div> -->
        </div>
    </div>
</template>

<script>
import AnswerPortrait from './AnswerPortrait.vue'
export default {
  props: {
    h5ConfigData: {
      type: Object
    },

    answerModel: {
      type: Object
    },

    owner: String
  },

  components: {
    AnswerPortrait
  },

  methods: {
    changeInput (val) {
      this.$emit('changeInput', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
    color: #4e82ff;
    margin-bottom: 16px;
    span {
        font-size: 30px; /*px*/
    }
}

button {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    padding: 14px 18px 0px;
    border: none;
    text-align: center;
    white-space: nowrap;
    background: #fff;
    -webkit-appearance: none;
    outline: none;
    transition: 0.1s;
    user-select: none;
    cursor: pointer;
    font-size: 28px;
    font-weight: 400;
    color: #949aa1;
    line-height: 36px;
    &.btn-re {
        border-color: #dcdee0;
        color: #34404d;
    }

    &:active {
        background: #fff;
        border-color: #fff;
        color: #949aa1;
    }
    img {
        width: 32px;
        height: 32px;
    }
}

.answer {
    &-content {
        position: relative;
        max-width: 560px;
        padding: 20px 24px;
        line-height: 44px;
        font-size: 32px; /*px*/
        word-break: break-all;
        word-wrap: word-break;
        color: #111e2e;
        background: #ffffff;
        box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.02);
        border-radius: 12px;

        &-tt {
            padding: 0px 0 24px;
            font-weight: 400;
        }

        // &.has-affix {
        //     margin-bottom: 66px;
        // }

        &-affix {
            text-align: center;
            border-top: 1px solid #eaebec;
            margin-top: 16px;
            display: flex;
            justify-content: center;
        }
    }
}
.answerContentSjtu {
    background: #f3f4f6;
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/Answer/AnswerRecommend.vue